<template>
    <div
        v-if="maxPreviewRunningReached"
        class="loading-preview preview-button"
    >
        <div class="generation-spinner">
            <span
                v-loading="true"
                class="preview-spinner"
            >
            </span>
        </div>
        <p class="loading-title">The number of simultaneous running preview is reached</p>
        <p class="loading-wait">
            Your preview will start as soon as possible.
        </p>
        <button
            class="preview-cancel"
            v-if="canCancelPreviewGeneration"
            @click="cancelPreview('cancel')"
        >
            x Cancel preview
        </button>
    </div>
    <div
        v-else
        class="preview-button"
    >
        <div class="generation-spinner">
            <span
                v-loading="true"
                class="preview-spinner"
            >
            </span>
        </div>
        <p
            class="step-title"
            :style="{'font-size': fontSize, 'margin': margin}"
        >
            {{stepData.stepTitle}}
        </p>
        <p
            class="step-text"
            v-if="stepData.stepText"
        >
            {{stepData.stepText}}
        </p>
        <button
            class="preview-cancel"
            v-if="canCancelPreviewGeneration"
            @click="cancelPreview('cancel')"
        >
            x Cancel preview
        </button>
    </div>
</template>

<script>
    import PreviewStepMixin from '@/components/Mixins/preview-step-mixin.vue';
    export default {

        name: 'Ready',

        mixins: [PreviewStepMixin],

        props: {
            canCancelPreviewGeneration: {
                type: Boolean,
                default: true,
            },
        },

        data () {
            return {
                itemTowatch: {}
            };
        },
        mounted(){
            if (this.creationRequest && this.creationRequest.preview){
                this.itemTowatch = this.creationRequest.preview;
            }else if(this.preview && this.preview.url){
                this.itemTowatch = this.preview;
            }else {
                console.error('erreur');
            }

            if(this.itemTowatch.status === 'STOPPING'){
                this.$emit('onPreviewCreated',this.itemTowatch);
            }else {
                this.watchModelStatus(this.itemTowatch, 'RUNNING', 'FAILED_TO_START') // Rendre les status parametrable
                .then((response)=>{
                    this.$emit('onPreviewCreated',response);
                })
                .catch((response)=>{
                    this.$emit('setErrorVerboseStatus', response.verbose_status)
                    this.changeStep(2);
                });

            }

        },
        computed: {
            maxPreviewRunningReached(){
                return this.previewQuota !== undefined && this.previewQuota.current_previews === this.previewQuota.max_previews;
            }
        },
        methods: {

        }
    };
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Preview/PreviewStep/Ready/index.vue